<template>
  <div>
    <div class="modal-tnc modal fade in" tabindex="-1" role="dialog">
      <div class="modal-dialog" role="document">
        <div class="modal-content popup-tnc-bbb">
          <div class="modal-body">
            <div class="modal-body">
              <img
                src="/static/img/laka-event/laka-tnc-header.png"
                alt="Syarat & Ketentuan"
                class="tnc-image tnc-image--header"
              />
              <img src="/static/img/laka-event/laka-tnc-text.png" alt="Syarat & Ketentuan" class="tnc-image" />
            </div>
          </div>
          <div style="display: flex; width: 100%; justify-content: center; padding-bottom: 60px">
            <button class="button-tutup" @click.prevent="$emit('close')">Tutup</button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-backdrop fade in"></div>
  </div>
</template>

<script>
export default {
  name: 'Modal',
};
</script>

<style lang="scss" scoped>
.tnc-image {
  width: 100%;
  display: block;
}

.tnc-image--header {
  margin-bottom: 24px;
}

.modal-tnc {
  position: fixed;
  top: calc(50% - 50px);
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 10px;
  padding: 60px 45px;
  width: 90vw;
}
.modal-tnc > * {
  width: 100%;
  margin: 0;
}
.popup-tnc-bbb {
  background-color: #5e0223;
  border-radius: 20px;
  width: 880px;
  .button-tutup {
    background: #fff;
    border-radius: 48px;
    padding: 30px 120px;
    margin: 0 auto;
    color: #5e0223;
    font-family: 'Pretendard';
    font-size: 32px;
    font-weight: 700;
    line-height: 38.4px;
    text-align: center;
    width: 410px;
    height: 98px;
  }
  .modal-header,
  .modal-footer {
    border: 0;
  }
  .modal-body {
    position: relative;
    width: 100%;
    padding: 30px;
    .close {
      opacity: 1;
      position: absolute;
      top: -50px;
      right: -45px;
      z-index: 151;
    }
    img {
      object-fit: cover;
      width: 100%;
    }
  }
}
@media screen and (max-width: 950px) and (min-width: 900px) {
  .popup-tnc-bbb {
    width: 750px;
  }
  .modal-tnc {
    padding: 0px 45px;
    width: 90vw;
    height: fit-content;
  }
}
</style>
